import { Model } from '@vuex-orm/core'
import { MessageDto } from './message.interface'
import { Constants } from '@/constants'

export default class Message extends Model {
    static entity = 'messages'

    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(''),
            name: this.attr('')
        }
    }

    static async createOne(payload: MessageDto) {
        return await this.api().post(Constants.API.MESSAGE, payload)
    }

    static async findOne(id: number) {
        return await this.api().get(Constants.API.MESSAGE + "/" + id)
    }

    static async updateOne(id: number, payload: MessageDto) {
        return await this.api().patch(Constants.API.MESSAGE + "/" + id, payload)
    }

    static async removeOne(id: number) {
        return await this.api().delete(Constants.API.MESSAGE + "/" + id)
    }

    static apiConfig = {
        actions: {
            fetch: {
                method: 'get',
                url: '/messages'
            }
        }
    }
}
